import { Button, Col, Row } from 'antd';
import { ExcelIcon, WordIcon } from 'assets';
import LayoutComp from 'components/LayoutComp/Index';
import React, { useState, useEffect } from 'react';
import { STATIC_TEXT } from 'utils/constants';
import { BackArrow } from 'utils/svg';
import Navigation from 'components/Navigation';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import Loader from 'components/ui/Loader';
import { excelDownloader, filterQuestionsById, flattenData, wordDownload } from 'utils/functions';

const Download = ({ history }) => {
  const [loader, setLoader] = useState(false);
  const questionsState = useSelector((state) => state.question);
  const { questionsList = [], selectedQuestions = [], reportName = '' } = questionsState;
  const categoriesState = useSelector((state) => state.category);
  const { selectedCategories = [] } = categoriesState;

  // console.log('reportName', reportName);
  useEffect(() => {
    if (selectedCategories.length < 1) {
      history.push('/question_category');
    }

    // eslint-disable-next-line
  }, []);
  const handleBack = () => {
    history.push('/questions');
  };
  const handleHomebtn = () => {
    history.push('/');
  };

  // console.log('flattenData', flattenData(filterQuestionsById(questionsList, selectedQuestions)));
  const handleDownload = () => {
    const finaldata = flattenData(filterQuestionsById(questionsList, selectedQuestions));
    console.log('finaldata', finaldata);
    if (finaldata.length < 1) {
      return;
    }

    excelDownloader(finaldata, reportName, setLoader);
  };

  const handleDownloadWord = () => {
    const finaldata = filterQuestionsById(questionsList, selectedQuestions);
    wordDownload(finaldata, reportName, setLoader);
  };
  return (
    <div className="download">
      {loader && <Loader />}
      <LayoutComp history={history}>
        <div className="back-nav">
          <div onClick={handleBack}>
            <BackArrow />
          </div>
          {STATIC_TEXT['DOWNLOAD_SURVEY']}
        </div>
        <p className="sub-heading">{STATIC_TEXT['SELECT_OPTION_TO_DOWNLOAD_YOUR_SURVEY']}</p>
        <Row style={{ marginBottom: '15vh' }}>
          <Col span={11}>
            <div className="box-shadow">
              <div className={`${styles.boximage} box-image`}>
                <img src={ExcelIcon} alt="images" />
              </div>
              <div className="box-content">
                <div>
                  <p style={{ color: '#858585' }}>
                    {STATIC_TEXT.YOUR_FILE_OF_SURVEY_WILL_BE_DOWNLOAD_IN_THE_EXCEL_FORMAT}
                  </p>
                  <Button onClick={handleDownload} size="large">
                    {STATIC_TEXT.DOWNLOAD}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col span={11} offset={2}>
            <div className="box-shadow">
              <div className={`${styles.boximage} box-image`}>
                <img src={WordIcon} alt="images" />
              </div>

              <div className="box-content">
                <div>
                  <p style={{ color: '#858585' }}>
                    {STATIC_TEXT.YOUR_FILE_OF_SURVEY_WILL_BE_DOWNLOAD_IN_THE_WORD_FORMAT}
                  </p>
                  <Button size="large" onClick={handleDownloadWord}>
                    {STATIC_TEXT.DOWNLOAD}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Navigation
          handleReset={handleHomebtn}
          handleNext={handleBack}
          isReset={true}
          nexttext="Back"
          resetText="Home"
        />
      </LayoutComp>
    </div>
  );
};

export default Download;
